/**
 * Field-level validators plus a small schema runner.
 * Each validator returns an error string, or an empty string when valid.
 */

import { todayISO } from './format';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;
const PHONE_RE = /^[+]?[\d][\d\s\-()]{7,17}$/;

export const required = (label) => (value) => {
  const empty =
    value === null ||
    value === undefined ||
    (typeof value === 'string' && value.trim() === '') ||
    (Array.isArray(value) && value.length === 0);
  return empty ? `${label} is required` : '';
};

export const minLength = (label, min) => (value) =>
  value && String(value).trim().length < min
    ? `${label} must be at least ${min} characters`
    : '';

export const email = (value) =>
  value && !EMAIL_RE.test(String(value).trim()) ? 'Enter a valid email address' : '';

export const phone = (value) =>
  value && !PHONE_RE.test(String(value).trim())
    ? 'Enter a valid phone number (8–18 digits)'
    : '';

export const positiveNumber = (label) => (value) => {
  if (value === '' || value === null || value === undefined) return '';
  const n = Number(value);
  if (Number.isNaN(n)) return `${label} must be a number`;
  if (n <= 0) return `${label} must be greater than zero`;
  return '';
};

export const notPastDate = (label) => (value) =>
  value && value < todayISO() ? `${label} cannot be in the past` : '';

/**
 * Run a `{ field: [validators] }` schema against a values object.
 * Returns `{ field: message }` containing only the fields that failed.
 */
export function validate(values, schema) {
  const errors = {};
  Object.entries(schema).forEach(([field, rules]) => {
    for (const rule of rules) {
      const message = rule(values[field], values);
      if (message) {
        errors[field] = message;
        break;
      }
    }
  });
  return errors;
}
